module.exports = __webpack_public_path__ + "img/flower-type04.658b8614.png";